// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__Zyn_1","mainButton":"style_mainButton__33qj_","buttonTittle":"style_buttonTittle__26Hu3"};